<template>
    <BreadCrumb PageTitle="Liste des qualifications" />
    <ListeQualification />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeQualification from "../../components/Qualification/ListeQualification.vue";

  
    export default defineComponent({
      name: "ListeQualificationPage",
      components: {
        BreadCrumb,
        ListeQualification,
      },
    });
  </script>